// Scripts para el frontend
